'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void import('@/logger').then(({ logger }) => {
      logger.error(error, 'Error');
    });
  }, [error]);

  return (
    <div className="mx-auto my-8 flex max-w-md flex-col rounded-lg border border-error-200 bg-error-50 p-4 shadow-sm">
      <h3 className="text-lg font-semibold text-error-800">
        Something went wrong
      </h3>
      <p className="mt-2 text-sm text-error-700">
        There was an error loading this content. Please try again later.
      </p>
      <button
        type="button"
        className="mt-4 w-full rounded-md border border-error-300 bg-error-100 px-4 py-2 text-sm font-medium text-error-700 transition-colors hover:bg-error-200 focus:outline-none focus:ring-2 focus:ring-error-500 focus:ring-offset-2"
        onClick={() => reset()}
      >
        Try again
      </button>
    </div>
  );
}
